<div class="mb-xl widget-area">

  <div [style.display]="'grid'"
       [style.gap]="'10px'"
       [style.flex]="'3'">
    @if (canAccessTile(['TRACK_TRACE'])) {
      <app-track-trace-widget class="widget"></app-track-trace-widget>
    }
    @if (canAccessTile([
      'BULK_BILL_RECEIPT',
      'BULK_BILL',
      'CREDIT_NOTE',
      'VETERINARY_DRUG',
      'TRANSFUSION',
      'REIMPORT',
      'EXTENDED_BENEFIT'
    ])) {
      <app-search-widget class="widget"></app-search-widget>
    }

    @if (canAccessTile(['TRACK_TRACE'])) {
      <app-tracking-widget class="widget"></app-tracking-widget>
    }
  </div>
  <div [style.display]="'grid'"
       [style.gap]="'10px'"
       [style.flex]="'2'">
    @if (canAccessTile(['MY_SALES'])) {
      <app-revenue-widget class="widget"></app-revenue-widget>
    }
    @if (canAccessTile(['MY_SALES']) && hasTargetRxPackets()) {
      <app-target-widget class="widget"></app-target-widget>
    }
  </div>
</div>
